import { BreakpointObserver } from '@angular/cdk/layout';
import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthStoreService } from './core/auth/auth-store.service';
import { Inject } from '@angular/core';
import { ENVIRONMENT } from './core/models/environment.token';
import { EnvironmentInterface } from './core/models/environment.interface';
import { Router } from '@angular/router';

enum View {
  Mobile,
  DesktopLoggedIn,
  DesktopLoggedOut
}

@Component({
  selector: 'dl-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None, // TODO Can be deleted probably
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit, AfterViewInit {
  
  public view = View;
  public view$: Observable<View> = this.breakpointObserver.observe('(min-width: 600px)').pipe(
    map(result => result.matches),
    map((desktop: boolean) => {
      if (!desktop) {
        return View.Mobile;
      } else {
        if (this.authStoreService.isLoggedIn) {
          return View.DesktopLoggedIn;
        } else {
          return View.DesktopLoggedOut;
        }
      }
    })
  );

  public constructor(private breakpointObserver: BreakpointObserver, private authStoreService: AuthStoreService, /*private analyticsService: AnalyticsService, private countryLanguageService: CountryLanguageService, private regionDialogService: RegionDialogService, private availabilitiesService: AvailabilitiesService, private userEservices: UserEServicesService, private learnMoreService: LearnMoreDialogService, private liveChatService: LiveChatService, private getHelpTicketUtilService: GetHelpTicketUtilService, @Inject(ENVIRONMENT) private environment: EnvironmentInterface,*/ private router: Router) {}

  public ngOnInit(): void {
    this.router.events.subscribe((nav) => window.scrollTo(0,0));
  }

  public ngAfterViewInit(): void {}
}
